var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-popover',{attrs:{"offset":"16","placement":"top"}},[_c('info-icon',{class:{ 'tooltip--dark': _vm.dark },attrs:{"alt":"tooltip"}}),_c('template',{slot:"popover"},[_vm._t("default")],2)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }